export type LegalBlock = { type: "title" | "heading" | "paragraph"; text: string };

const content: LegalBlock[] = [
  {
    type: "title",
    text: "Chính sách quyền riêng tư",
  },
  {
    type: "paragraph",
    text: "Chào mừng bạn sử dụng ứng dụng Vay Có Ngay (sau đây gọi là “Ứng dụng”) được vận hành bởi COMPUTER GARAGE. (sau đây gọi là “Chúng tôi”).",
  },
  {
    type: "paragraph",
    text: "Chúng tôi đặc biệt coi trọng việc bảo vệ dữ liệu cá nhân và quyền riêng tư của bạn. Chúng tôi cam kết thu thập, sử dụng và quản lý dữ liệu cá nhân của bạn một cách hợp pháp, minh bạch và an toàn theo các quy định pháp luật hiện hành.",
  },
  {
    type: "paragraph",
    text: "Nhằm giúp bạn hiểu rõ hơn về cách chúng tôi xử lý dữ liệu cá nhân, Chính sách quyền riêng tư này sẽ giải thích:",
  },
  {
    type: "paragraph",
    text: "Các loại dữ liệu cá nhân mà chúng tôi thu thập;",
  },
  {
    type: "paragraph",
    text: "Cách thức chúng tôi sử dụng, lưu trữ và bảo vệ dữ liệu cá nhân của bạn;",
  },
  {
    type: "paragraph",
    text: "Các quyền mà bạn được hưởng trong quá trình xử lý dữ liệu cá nhân.",
  },
  {
    type: "paragraph",
    text: "Khi sử dụng Ứng dụng, bạn xác nhận rằng bạn đã đọc, hiểu và đồng ý với toàn bộ nội dung của Chính sách quyền riêng tư này.",
  },
  {
    type: "paragraph",
    text: "Chính sách này áp dụng cho tất cả sản phẩm và dịch vụ do chúng tôi cung cấp. Vui lòng đọc kỹ và hiểu đầy đủ nội dung chính sách trước khi sử dụng dịch vụ, đặc biệt là các điều khoản liên quan đến quyền và lợi ích của bạn đối với dữ liệu cá nhân.",
  },
  {
    type: "paragraph",
    text: "Khi bạn bắt đầu sử dụng sản phẩm hoặc dịch vụ của chúng tôi, hoặc tiếp tục sử dụng dịch vụ sau khi chính sách được cập nhật, điều đó có nghĩa là bạn đã đọc, hiểu và đồng ý với nội dung của Chính sách quyền riêng tư này cũng như các phiên bản cập nhật sau đó.",
  },
  {
    type: "paragraph",
    text: "Nếu bạn không đồng ý với bất kỳ nội dung nào trong chính sách này, vui lòng ngừng sử dụng sản phẩm hoặc dịch vụ của chúng tôi.",
  },
  {
    type: "paragraph",
    text: "Thông qua Chính sách quyền riêng tư này, bạn có thể tìm hiểu các nội dung sau:",
  },
  {
    type: "paragraph",
    text: "Cam kết của chúng tôi",
  },
  {
    type: "paragraph",
    text: "Cách chúng tôi thu thập và sử dụng dữ liệu cá nhân",
  },
  {
    type: "paragraph",
    text: "Thời hạn ủy quyền xử lý dữ liệu cá nhân",
  },
  {
    type: "paragraph",
    text: "Cách chúng tôi lưu trữ và bảo vệ dữ liệu cá nhân",
  },
  {
    type: "paragraph",
    text: "Các quyền của bạn",
  },
  {
    type: "paragraph",
    text: "Cách chúng tôi bảo vệ dữ liệu cá nhân của trẻ vị thành niên",
  },
  {
    type: "paragraph",
    text: "Cập nhật và thông báo về chính sách",
  },
  {
    type: "paragraph",
    text: "Cách liên hệ với chúng tôi",
  },
  {
    type: "heading",
    text: "1. Cam kết của chúng tôi",
  },
  {
    type: "paragraph",
    text: "Chúng tôi hiểu rõ tầm quan trọng của dữ liệu cá nhân đối với bạn và luôn xem việc bảo vệ an toàn thông tin của bạn là trách nhiệm quan trọng.",
  },
  {
    type: "paragraph",
    text: "Chúng tôi sẽ áp dụng các biện pháp hợp lý và hiệu quả để bảo vệ dữ liệu cá nhân của bạn, đồng thời duy trì sự tin tưởng của bạn đối với chúng tôi.",
  },
  {
    type: "paragraph",
    text: "Trong quá trình xử lý dữ liệu cá nhân, chúng tôi tuân thủ các nguyên tắc sau:",
  },
  {
    type: "paragraph",
    text: "Nguyên tắc trách nhiệm và quyền hạn tương ứng;",
  },
  {
    type: "paragraph",
    text: "Nguyên tắc xác định rõ mục đích xử lý;",
  },
  {
    type: "paragraph",
    text: "Nguyên tắc minh bạch và sự đồng ý của chủ thể dữ liệu;",
  },
  {
    type: "paragraph",
    text: "Nguyên tắc giới hạn trong phạm vi cần thiết;",
  },
  {
    type: "paragraph",
    text: "Nguyên tắc đảm bảo an toàn dữ liệu;",
  },
  {
    type: "paragraph",
    text: "Nguyên tắc đảm bảo quyền tham gia của chủ thể dữ liệu;",
  },
  {
    type: "paragraph",
    text: "Nguyên tắc công khai và minh bạch.",
  },
  {
    type: "paragraph",
    text: "Thông qua Chính sách quyền riêng tư này, chúng tôi mong muốn giúp bạn hiểu rõ về các chức năng dịch vụ, phạm vi dữ liệu được thu thập, phương thức xử lý dữ liệu cũng như các phương thức để bạn chủ động quản lý dữ liệu cá nhân của mình.",
  },
  {
    type: "heading",
    text: "1.1 Chúng tôi chỉ xử lý dữ liệu cá nhân trong phạm vi cần thiết và hợp lý",
  },
  {
    type: "paragraph",
    text: "Chúng tôi cam kết chỉ thu thập và xử lý dữ liệu cá nhân của bạn trong phạm vi cần thiết, hợp lý nhằm cung cấp và duy trì các chức năng dịch vụ.",
  },
  {
    type: "paragraph",
    text: "Việc xử lý dữ liệu cá nhân của bạn chủ yếu nhằm:",
  },
  {
    type: "paragraph",
    text: "Tuân thủ các yêu cầu của pháp luật hiện hành;",
  },
  {
    type: "paragraph",
    text: "Cung cấp sản phẩm và dịch vụ an toàn, ổn định, hiệu quả hơn;",
  },
  {
    type: "paragraph",
    text: "Cải thiện hoạt động vận hành của nền tảng và nâng cao trải nghiệm người dùng.",
  },
  {
    type: "heading",
    text: "1.2 Chúng tôi chỉ xử lý dữ liệu cá nhân khi bạn đã được thông báo và đồng ý",
  },
  {
    type: "paragraph",
    text: "Chúng tôi cam kết thông báo cho bạn một cách rõ ràng và minh bạch về:",
  },
  {
    type: "paragraph",
    text: "Danh tính và thông tin liên hệ của chúng tôi;",
  },
  {
    type: "paragraph",
    text: "Loại dữ liệu cá nhân mà chúng tôi cần xử lý;",
  },
  {
    type: "paragraph",
    text: "Mục đích, phương thức xử lý và thời gian lưu trữ dữ liệu.",
  },
  {
    type: "paragraph",
    text: "Chúng tôi sẽ cố gắng sử dụng ngôn ngữ đơn giản, dễ hiểu để giải thích các nội dung liên quan.",
  },
  {
    type: "paragraph",
    text: "Dữ liệu cá nhân nhạy cảm là những dữ liệu mà khi bị tiết lộ, cung cấp trái phép hoặc sử dụng không đúng mục đích có thể gây ảnh hưởng đến an toàn cá nhân, tài sản, danh dự, sức khỏe tinh thần hoặc các quyền lợi hợp pháp khác của cá nhân.",
  },
  {
    type: "paragraph",
    text: "Trước khi xử lý dữ liệu cá nhân nhạy cảm của bạn, chúng tôi sẽ thông báo về sự cần thiết của việc xử lý, các ảnh hưởng có thể xảy ra đối với quyền lợi cá nhân và thực hiện việc xin sự đồng ý riêng của bạn theo quy định pháp luật.",
  },
  {
    type: "paragraph",
    text: "Chúng tôi tôn trọng quyền lựa chọn của bạn.",
  },
  {
    type: "paragraph",
    text: "Khi phạm vi thu thập dữ liệu cá nhân, mục đích xử lý hoặc phương thức xử lý có sự thay đổi, chúng tôi sẽ thông báo kịp thời và thực hiện xin lại sự đồng ý của bạn theo yêu cầu pháp luật.",
  },
  {
    type: "heading",
    text: "1.3 Chúng tôi tôn trọng quyền quản lý dữ liệu cá nhân của bạn",
  },
  {
    type: "paragraph",
    text: "Chúng tôi sẽ áp dụng các biện pháp hợp lý để đảm bảo dữ liệu cá nhân do bạn cung cấp không bị thay đổi, phá hủy hoặc mất mát trái phép.",
  },
  {
    type: "paragraph",
    text: "Chúng tôi hiểu sự quan tâm của bạn đối với vấn đề bảo mật dữ liệu cá nhân và cung cấp các phương thức để bạn thực hiện quyền của chủ thể dữ liệu, bao gồm nhưng không giới hạn:",
  },
  {
    type: "paragraph",
    text: "Tra cứu dữ liệu cá nhân;",
  },
  {
    type: "paragraph",
    text: "Nhận bản sao dữ liệu cá nhân;",
  },
  {
    type: "paragraph",
    text: "Chỉnh sửa hoặc bổ sung dữ liệu cá nhân;",
  },
  {
    type: "paragraph",
    text: "Rút lại sự đồng ý;",
  },
  {
    type: "paragraph",
    text: "Yêu cầu xóa dữ liệu cá nhân.",
  },
  {
    type: "heading",
    text: "1.4 Chúng tôi áp dụng các biện pháp cần thiết để đảm bảo an toàn dữ liệu cá nhân",
  },
  {
    type: "paragraph",
    text: "Chúng tôi cam kết áp dụng các tiêu chuẩn bảo mật phổ biến trong ngành cùng các biện pháp kỹ thuật và quản lý cần thiết nhằm bảo vệ dữ liệu cá nhân của bạn.",
  },
  {
    type: "paragraph",
    text: "Các biện pháp bao gồm nhưng không giới hạn:",
  },
  {
    type: "paragraph",
    text: "Áp dụng các biện pháp bảo vệ về phần cứng, phần mềm, dữ liệu và cơ sở hạ tầng phù hợp với yêu cầu pháp luật và tiêu chuẩn bảo mật hiện hành;",
  },
  {
    type: "paragraph",
    text: "Xây dựng hệ thống quản lý an toàn thông tin hoàn chỉnh;",
  },
  {
    type: "paragraph",
    text: "Đào tạo nhân viên liên quan về bảo mật dữ liệu;",
  },
  {
    type: "paragraph",
    text: "Ký kết thỏa thuận bảo mật hoặc cam kết bảo mật với nhân viên có liên quan đến việc xử lý dữ liệu cá nhân;",
  },
  {
    type: "paragraph",
    text: "Hạn chế quyền truy cập dữ liệu cá nhân nhằm ngăn chặn việc truy cập hoặc sử dụng trái phép.",
  },
  {
    type: "paragraph",
    text: "Chúng tôi sẽ liên tục cải thiện hệ thống bảo vệ dữ liệu nhằm đảm bảo an toàn cho thông tin cá nhân của bạn.",
  },
  {
    type: "heading",
    text: "2. Cách chúng tôi thu thập và sử dụng dữ liệu cá nhân",
  },
  {
    type: "paragraph",
    text: "Trong quá trình bạn đăng ký, đăng nhập và sử dụng các sản phẩm, dịch vụ do chúng tôi cung cấp, bạn đồng ý và ủy quyền cho chúng tôi thu thập, sử dụng các dữ liệu cá nhân cần thiết nhằm đáp ứng nhu cầu cung cấp dịch vụ.",
  },
  {
    type: "paragraph",
    text: "Chúng tôi cam kết không thu thập các dữ liệu cá nhân bị pháp luật cấm thu thập, đồng thời không sử dụng dữ liệu cá nhân của bạn ngoài phạm vi đã được thông báo và thỏa thuận.",
  },
  {
    type: "paragraph",
    text: "Trong quá trình cung cấp dịch vụ, chúng tôi có thể thu thập hai nhóm dữ liệu sau:",
  },
  {
    type: "paragraph",
    text: "Nhóm thứ nhất: Dữ liệu cần thiết cho các chức năng cơ bản của dịch vụ",
  },
  {
    type: "paragraph",
    text: "Đây là các dữ liệu cần thiết để đảm bảo sản phẩm và dịch vụ có thể hoạt động bình thường.",
  },
  {
    type: "paragraph",
    text: "Nếu bạn từ chối cung cấp các dữ liệu này, bạn có thể không thể sử dụng một số hoặc toàn bộ chức năng cơ bản của dịch vụ.",
  },
  {
    type: "paragraph",
    text: "Nhóm thứ hai: Dữ liệu cần thiết cho các chức năng mở rộng",
  },
  {
    type: "paragraph",
    text: "Một số chức năng không thuộc dịch vụ cơ bản có thể yêu cầu thu thập thêm một số dữ liệu liên quan.",
  },
  {
    type: "paragraph",
    text: "Bạn có quyền lựa chọn có đồng ý cung cấp các dữ liệu này hay không.",
  },
  {
    type: "paragraph",
    text: "Nếu bạn từ chối cung cấp, một số tính năng có thể không hoạt động hoặc không đạt được hiệu quả dịch vụ mong muốn, nhưng điều này không ảnh hưởng đến việc sử dụng các chức năng cơ bản.",
  },
  {
    type: "paragraph",
    text: "Chúng tôi chỉ thu thập dữ liệu cần thiết khi bạn sử dụng các chức năng tương ứng.",
  },
  {
    type: "paragraph",
    text: "Khi bạn ngừng sử dụng chức năng đó, chúng tôi sẽ dừng việc tiếp tục thu thập và sử dụng các dữ liệu liên quan.",
  },
  {
    type: "paragraph",
    text: "Nếu trong tương lai chúng tôi cần thay đổi loại dữ liệu thu thập hoặc mục đích sử dụng dữ liệu, chúng tôi sẽ thông báo trước cho bạn bằng phương thức phù hợp và xin lại sự đồng ý của bạn theo quy định.",
  },
  {
    type: "heading",
    text: "2.1 Thông tin cá nhân cơ bản",
  },
  {
    type: "paragraph",
    text: "Nhằm phục vụ mục đích xác thực danh tính, đăng ký tài khoản, đánh giá rủi ro tín dụng và đảm bảo an toàn dịch vụ, chúng tôi sẽ thu thập số điện thoại mà bạn sử dụng để đăng ký tài khoản như một thông tin nhận dạng chính.",
  },
  {
    type: "paragraph",
    text: "Tùy theo nhu cầu cung cấp dịch vụ, chúng tôi có thể tiếp tục thu thập các thông tin sau:",
  },
  {
    type: "paragraph",
    text: "Họ và tên;",
  },
  {
    type: "paragraph",
    text: "Giới tính;",
  },
  {
    type: "paragraph",
    text: "Thông tin nghề nghiệp;",
  },
  {
    type: "paragraph",
    text: "Thông tin liên quan đến công việc;",
  },
  {
    type: "paragraph",
    text: "Thông tin gia đình;",
  },
  {
    type: "paragraph",
    text: "Loại và số giấy tờ tùy thân;",
  },
  {
    type: "paragraph",
    text: "Hình ảnh giấy tờ tùy thân;",
  },
  {
    type: "paragraph",
    text: "Hình ảnh khuôn mặt;",
  },
  {
    type: "paragraph",
    text: "Thông tin nhận dạng sinh trắc học;",
  },
  {
    type: "paragraph",
    text: "Thông tin tài khoản ngân hàng.",
  },
  {
    type: "paragraph",
    text: "Các thông tin trên được sử dụng chủ yếu để:",
  },
  {
    type: "paragraph",
    text: "Xác minh tính chính xác của danh tính người dùng;",
  },
  {
    type: "paragraph",
    text: "Thực hiện đánh giá rủi ro tín dụng;",
  },
  {
    type: "paragraph",
    text: "Đề xuất các dịch vụ phù hợp với nhu cầu của bạn;",
  },
  {
    type: "paragraph",
    text: "Đảm bảo các giao dịch trên nền tảng được thực hiện hợp pháp, an toàn và đáng tin cậy.",
  },
  {
    type: "paragraph",
    text: "Chúng tôi sẽ quản lý và bảo vệ các dữ liệu cá nhân này theo đúng yêu cầu của pháp luật hiện hành.",
  },
  {
    type: "heading",
    text: "2.2 Thu thập và sử dụng thông tin thiết bị",
  },
  {
    type: "paragraph",
    text: "Trong quá trình bạn sử dụng Ứng dụng, nhằm đảm bảo an toàn vận hành nền tảng, xác thực người dùng, phòng chống gian lận và nâng cao khả năng kiểm soát rủi ro, chúng tôi có thể thu thập một số thông tin liên quan đến thiết bị của bạn theo nhu cầu dịch vụ.",
  },
  {
    type: "heading",
    text: "2.2.1 Thông tin thiết bị",
  },
  {
    type: "paragraph",
    text: "Các thông tin có thể được thu thập bao gồm nhưng không giới hạn:",
  },
  {
    type: "paragraph",
    text: "Địa chỉ MAC;",
  },
  {
    type: "paragraph",
    text: "Model thiết bị;",
  },
  {
    type: "paragraph",
    text: "IMEI;",
  },
  {
    type: "paragraph",
    text: "GAID;",
  },
  {
    type: "paragraph",
    text: "Dung lượng bộ nhớ RAM;",
  },
  {
    type: "paragraph",
    text: "Địa chỉ IP;",
  },
  {
    type: "paragraph",
    text: "Thông tin Wi-Fi;",
  },
  {
    type: "paragraph",
    text: "Tình trạng pin;",
  },
  {
    type: "paragraph",
    text: "Độ phân giải màn hình;",
  },
  {
    type: "paragraph",
    text: "Cài đặt ngôn ngữ hệ thống;",
  },
  {
    type: "paragraph",
    text: "Thông tin nhà sản xuất thiết bị;",
  },
  {
    type: "paragraph",
    text: "Loại kết nối mạng;",
  },
  {
    type: "paragraph",
    text: "Tên nhà cung cấp dịch vụ di động.",
  },
  {
    type: "paragraph",
    text: "Các thông tin thiết bị này được sử dụng chủ yếu nhằm:",
  },
  {
    type: "paragraph",
    text: "Nâng cao độ chính xác trong việc nhận diện danh tính;",
  },
  {
    type: "paragraph",
    text: "Hỗ trợ đánh giá rủi ro;",
  },
  {
    type: "paragraph",
    text: "Phát hiện các hành vi bất thường của thiết bị;",
  },
  {
    type: "paragraph",
    text: "Ngăn chặn gian lận và các hành vi vi phạm.",
  },
  {
    type: "paragraph",
    text: "Nếu bạn từ chối cung cấp các thông tin thiết bị liên quan, điều này không ảnh hưởng đến việc sử dụng các chức năng cơ bản của Ứng dụng, tuy nhiên có thể ảnh hưởng đến khả năng đánh giá rủi ro và độ chính xác của một số đề xuất dịch vụ.",
  },
  {
    type: "heading",
    text: "2.2.2 Danh sách ứng dụng đã cài đặt",
  },
  {
    type: "paragraph",
    text: "Nhằm nâng cao khả năng nhận diện rủi ro, đảm bảo tính an toàn và tuân thủ trong quá trình cung cấp dịch vụ cho vay, sau khi nhận được sự đồng ý rõ ràng của bạn, chúng tôi có thể thu thập thông tin về danh sách các ứng dụng đã được cài đặt trên thiết bị.",
  },
  {
    type: "paragraph",
    text: "Các thông tin có thể bao gồm:",
  },
  {
    type: "paragraph",
    text: "Tên ứng dụng;",
  },
  {
    type: "paragraph",
    text: "Tên gói ứng dụng (Package Name);",
  },
  {
    type: "paragraph",
    text: "Thời gian cài đặt và cập nhật ứng dụng;",
  },
  {
    type: "paragraph",
    text: "Phiên bản ứng dụng;",
  },
  {
    type: "paragraph",
    text: "Ứng dụng có phải là ứng dụng hệ thống hay không;",
  },
  {
    type: "paragraph",
    text: "Nhãn ứng dụng;",
  },
  {
    type: "paragraph",
    text: "Đường dẫn cài đặt ứng dụng.",
  },
  {
    type: "paragraph",
    text: "Các thông tin trên chỉ được sử dụng cho mục đích đánh giá rủi ro và phân tích an toàn.",
  },
  {
    type: "paragraph",
    text: "Toàn bộ dữ liệu được thu thập sẽ được mã hóa, truyền tải và lưu trữ an toàn tại:",
  },
  {
    type: "paragraph",
    text: "admin.vaycongay.net",
  },
  {
    type: "paragraph",
    text: "Chúng tôi không sử dụng các thông tin này cho bất kỳ mục đích nào ngoài phạm vi dịch vụ, đồng thời không cung cấp cho bất kỳ bên thứ ba không liên quan nào khi chưa có sự cho phép của bạn.",
  },
  {
    type: "heading",
    text: "2.2.3 Quyền truy cập vị trí gần đúng",
  },
  {
    type: "paragraph",
    text: "Sau khi nhận được sự đồng ý của bạn, chúng tôi có thể thu thập thông tin vị trí gần đúng của bạn.",
  },
  {
    type: "paragraph",
    text: "Thông tin này chủ yếu được sử dụng để:",
  },
  {
    type: "paragraph",
    text: "Xác định bạn có đang ở khu vực được hỗ trợ dịch vụ hay không;",
  },
  {
    type: "paragraph",
    text: "Hỗ trợ quá trình đánh giá tín dụng;",
  },
  {
    type: "paragraph",
    text: "Nâng cao khả năng kiểm soát rủi ro;",
  },
  {
    type: "paragraph",
    text: "Đảm bảo dịch vụ đáp ứng các yêu cầu pháp luật liên quan.",
  },
  {
    type: "paragraph",
    text: "Chúng tôi cam kết không sử dụng thông tin vị trí của bạn cho các mục đích không liên quan đến dịch vụ và không tiết lộ thông tin này cho bên thứ ba khi chưa có sự đồng ý rõ ràng của bạn.",
  },
  {
    type: "heading",
    text: "2.2.4 Quyền truy cập camera",
  },
  {
    type: "paragraph",
    text: "Trong quá trình xác minh danh tính, chúng tôi có thể yêu cầu quyền truy cập camera trên thiết bị của bạn.",
  },
  {
    type: "paragraph",
    text: "Quyền này chỉ được sử dụng cho các mục đích:",
  },
  {
    type: "paragraph",
    text: "Chụp và tải lên hình ảnh giấy tờ tùy thân;",
  },
  {
    type: "paragraph",
    text: "Thu thập hình ảnh khuôn mặt;",
  },
  {
    type: "paragraph",
    text: "Xác minh danh tính thực tế của bạn;",
  },
  {
    type: "paragraph",
    text: "Ngăn chặn hành vi giả mạo danh tính và gian lận.",
  },
  {
    type: "paragraph",
    text: "Thông tin hình ảnh được thu thập chỉ phục vụ mục đích xác minh danh tính và không được sử dụng cho các mục đích khác.",
  },
  {
    type: "paragraph",
    text: "Toàn bộ dữ liệu hình ảnh sẽ được mã hóa trước khi truyền đến máy chủ của chúng tôi:",
  },
  {
    type: "paragraph",
    text: "admin.vaycongay.net",
  },
  {
    type: "paragraph",
    text: "và được lưu trữ theo các tiêu chuẩn bảo mật phù hợp.",
  },
  {
    type: "paragraph",
    text: "Chúng tôi không sử dụng các thông tin này cho mục đích không liên quan và không cung cấp cho bất kỳ bên thứ ba nào khi chưa có sự đồng ý của bạn.",
  },
  {
    type: "heading",
    text: "2.2.5 Quyền truy cập tin nhắn (SMS)",
  },
  {
    type: "paragraph",
    text: "Để hỗ trợ đánh giá tín dụng và kiểm soát rủi ro, chúng tôi có thể thu thập các thông tin trong tin nhắn liên quan đến hoạt động tài chính của bạn, bao gồm nhưng không giới hạn ở: thông báo khoản vay, nhắc nhở thanh toán, mã xác thực giao dịch (OTP), thông tin hóa đơn và các nội dung liên quan khác.",
  },
  {
    type: "paragraph",
    text: "Dữ liệu cụ thể được thu thập có thể bao gồm số điện thoại người gửi, thời gian gửi hoặc nhận tin nhắn và các thông tin liên quan.Nội dung tin nhắn được thu thập sẽ được mã hóa, truyền tải an toàn và lưu trữ trên máy chủ của chúng tôi tại: https://api.vaycongay.net.",
  },
  {
    type: "paragraph",
    text: "Những thông tin này chỉ được sử dụng cho mục đích đánh giá rủi ro, không được sử dụng cho bất kỳ mục đích nào không liên quan đến dịch vụ này và sẽ không được tiết lộ cho bất kỳ bên thứ ba không liên quan nào nếu chưa có sự cho phép của bạn.",
  },
  {
    type: "heading",
    text: "2.2.6 Quyền truy cập nhật ký cuộc gọi",
  },
  {
    type: "paragraph",
    text: "Để hỗ trợ đăng ký, đăng nhập và xác thực tài khoản, Ứng dụng có thể truy cập một số thông tin trong nhật ký cuộc gọi gần đây sau khi bạn cấp quyền truy cập.",
  },
  {
    type: "paragraph",
    text: "Trong quá trình đăng ký hoặc đăng nhập, hệ thống có thể thực hiện cuộc gọi xác minh tự động đến số điện thoại bạn đã đăng ký. Ứng dụng có thể kiểm tra thông tin liên quan đến cuộc gọi này, bao gồm số điện thoại, thời điểm gọi và trạng thái cuộc gọi, nhằm xác định việc xác minh đã hoàn tất hay chưa.",
  },
  {
    type: "paragraph",
    text: "Thông tin nhật ký cuộc gọi chỉ được sử dụng để:",
  },
  {
    type: "paragraph",
    text: "• Xác minh danh tính;",
  },
  {
    type: "paragraph",
    text: "• Xác thực tài khoản;",
  },
  {
    type: "paragraph",
    text: "• Hỗ trợ quá trình đăng nhập thuận tiện hơn.",
  },
  {
    type: "paragraph",
    text: "Chúng tôi không sử dụng thông tin nhật ký cuộc gọi cho mục đích quảng cáo, tiếp thị hoặc đánh giá tín dụng; không mua bán hoặc chia sẻ thông tin này cho bên thứ ba vì mục đích thương mại.",
  },
  {
    type: "heading",
    text: "2.3 Đăng ký và đăng nhập bằng tài khoản TikTok",
  },
  {
    type: "heading",
    text: "2.3.1 Dữ liệu được thu thập và mục đích sử dụng",
  },
  {
    type: "paragraph",
    text: "Khi bạn chủ động lựa chọn đăng ký hoặc đăng nhập vào Vay Có Ngay bằng tài khoản TikTok, sau khi bạn cấp quyền, chúng tôi nhận và xử lý thông tin trong phạm vi bạn đã cho phép.",
  },
  {
    type: "paragraph",
    text: "Các quyền được yêu cầu gồm user.info.basic, user.info.stats và video.list. Việc truy cập phụ thuộc vào quyền được TikTok phê duyệt và sự cho phép của bạn.",
  },
  {
    type: "paragraph",
    text: "• Mã định danh tài khoản TikTok trong ứng dụng (open_id): để nhận diện tài khoản TikTok, tạo hoặc liên kết tài khoản Vay Có Ngay và hoàn tất đăng nhập.",
  },
  {
    type: "paragraph",
    text: "• Tên hiển thị và ảnh đại diện: để hiển thị thông tin hồ sơ trong tài khoản Vay Có Ngay.",
  },
  {
    type: "paragraph",
    text: "• Thông tin thống kê tài khoản (user.info.stats): số người theo dõi, số tài khoản đang theo dõi, tổng số lượt thích nhận được và số video công khai, phục vụ đánh giá tín dụng và kiểm soát rủi ro.",
  },
  {
    type: "paragraph",
    text: "• Danh sách video công khai (video.list): thông tin về các video công khai được trả về qua API và trong phạm vi bạn cho phép, phục vụ đánh giá tín dụng và kiểm soát rủi ro.",
  },
  {
    type: "paragraph",
    text: "Chúng tôi không tải xuống video và không phân tích nội dung video.",
  },
  {
    type: "paragraph",
    text: "Chúng tôi cũng xử lý mã ủy quyền và mã truy cập cần thiết để thực hiện quy trình đăng nhập và truy cập thông tin đã được bạn cho phép. Chúng tôi không yêu cầu bạn cung cấp mật khẩu TikTok cho Vay Có Ngay.",
  },
  {
    type: "paragraph",
    text: "Chúng tôi chỉ xử lý các thông tin này trong phạm vi cần thiết cho những mục đích đã nêu. Nếu thay đổi mục đích sử dụng, chúng tôi sẽ thông báo và xin sự đồng ý riêng khi pháp luật áp dụng yêu cầu.",
  },
  {
    type: "heading",
    text: "2.3.2 Mối quan hệ với dịch vụ tín dụng",
  },
  {
    type: "paragraph",
    text: "Vay Có Ngay trực tiếp thực hiện việc đánh giá rủi ro tín dụng dựa trên các thông tin TikTok được bạn cho phép xử lý. Bạn được tự do lựa chọn có cấp quyền hay không và có thể rút lại quyền đã cấp. Việc từ chối cấp quyền hoặc rút lại quyền không ảnh hưởng đến việc sử dụng các chức năng khác của ứng dụng.",
  },
  {
    type: "paragraph",
    text: "Tích hợp TikTok được sử dụng cho đăng ký, đăng nhập, liên kết tài khoản và xử lý dữ liệu đã được cho phép để phục vụ đánh giá tín dụng, hỗ trợ xem xét cấp tín dụng và kiểm soát rủi ro. Đây không chỉ là chức năng đăng nhập. Việc đăng nhập TikTok không thay thế quy trình xác minh danh tính của dịch vụ tài chính. Trước khi xử lý dữ liệu TikTok cho mục đích tín dụng và kiểm soát rủi ro, chúng tôi thông báo rõ loại dữ liệu, mục đích sử dụng và xin sự đồng ý riêng khi pháp luật áp dụng yêu cầu.",
  },
  {
    type: "paragraph",
    text: "Các thông tin định danh, tài chính và dữ liệu khác cần thiết khi bạn đăng ký sử dụng dịch vụ tín dụng được thu thập và xử lý riêng theo Mục 2.1 và các nội dung tương ứng tại Mục 2.2 của Chính sách này.",
  },
  {
    type: "heading",
    text: "2.3.3 Trao đổi và chia sẻ thông tin",
  },
  {
    type: "paragraph",
    text: "Khi bạn sử dụng đăng nhập TikTok, chúng tôi trao đổi với TikTok những thông tin cần thiết để thực hiện việc cấp quyền và đăng nhập.",
  },
  {
    type: "paragraph",
    text: "Ngoài việc trao đổi thông tin cần thiết với TikTok để thực hiện cấp quyền và đăng nhập như đã nêu ở trên, Vay Có Ngay không chia sẻ dữ liệu người dùng được thu thập qua tích hợp TikTok hoặc kết quả, đặc trưng phân tích tín dụng được tạo ra từ dữ liệu này với bất kỳ bên thứ ba nào.",
  },
  {
    type: "paragraph",
    text: "Chúng tôi không cung cấp cho TikTok hồ sơ đăng ký vay, kết quả đánh giá tín dụng, số tiền vay hoặc lịch sử trả nợ của bạn.",
  },
  {
    type: "paragraph",
    text: "TikTok xử lý các thông tin do TikTok tự thu thập theo chính sách quyền riêng tư của TikTok, được công bố tại: https://www.tiktok.com/legal/page/row/privacy-policy/en.",
  },
  {
    type: "heading",
    text: "2.3.4 Lưu trữ và bảo vệ dữ liệu",
  },
  {
    type: "paragraph",
    text: "Chúng tôi lưu mã định danh và thông tin hồ sơ TikTok trong thời gian tài khoản còn được liên kết với TikTok và các thông tin này còn cần thiết để cung cấp chức năng đăng nhập, liên kết tài khoản và hiển thị hồ sơ. Đối với dữ liệu TikTok phục vụ đánh giá rủi ro tín dụng, chúng tôi chỉ lưu giữ trong thời gian còn cần thiết cho mục đích đã nêu và khi bạn còn cho phép việc xử lý. Khi bạn xóa tài khoản Vay Có Ngay, chúng tôi sẽ xóa dữ liệu thống kê tài khoản TikTok, danh sách video và các kết quả hoặc đặc trưng phân tích tín dụng được tạo ra từ những dữ liệu này. Mã truy cập được lưu trong thời gian cần thiết để duy trì quyền truy cập mà bạn cho phép; khi không còn cần thiết hoặc quyền truy cập bị thu hồi, chúng tôi ngừng sử dụng và xử lý việc xóa hoặc thu hồi mã theo quy trình áp dụng.",
  },
  {
    type: "paragraph",
    text: "Khi dữ liệu không còn cần thiết, bạn yêu cầu xóa dữ liệu hoặc đóng tài khoản, chúng tôi sẽ xóa hoặc ẩn danh hóa dữ liệu theo Chính sách này, trừ trường hợp cần lưu trữ theo yêu cầu pháp luật. Các biện pháp bảo vệ dữ liệu được thực hiện theo Mục 4.",
  },
  {
    type: "heading",
    text: "2.3.5 Rút lại quyền truy cập, hủy liên kết và yêu cầu xóa dữ liệu",
  },
  {
    type: "paragraph",
    text: "Bạn có thể quản lý hoặc thu hồi quyền truy cập của Vay Có Ngay thông qua chức năng quản lý ứng dụng được cấp quyền của TikTok. Bạn cũng có thể gửi yêu cầu hủy liên kết, rút lại sự đồng ý hoặc xóa dữ liệu TikTok mà chúng tôi lưu giữ đến service@vaycongay.net theo thông tin liên hệ tại Mục 8. Chúng tôi có thể yêu cầu thông tin cần thiết để xác minh quyền sở hữu tài khoản trước khi xử lý yêu cầu.",
  },
  {
    type: "paragraph",
    text: "Việc từ chối hoặc rút lại quyền sử dụng dữ liệu TikTok để đánh giá rủi ro tín dụng không ảnh hưởng đến các chức năng khác của ứng dụng. Nếu bạn thu hồi toàn bộ quyền đăng nhập TikTok hoặc hủy liên kết tài khoản TikTok, bạn có thể không tiếp tục đăng nhập bằng tài khoản TikTok đó cho đến khi cấp quyền và liên kết lại. Trước khi hủy liên kết, nếu cần tiếp tục truy cập tài khoản Vay Có Ngay, vui lòng liên hệ bộ phận hỗ trợ để được hướng dẫn về phương thức truy cập phù hợp.",
  },
  {
    type: "paragraph",
    text: "Việc thu hồi quyền truy cập trên TikTok không tự động đồng nghĩa với việc đóng tài khoản Vay Có Ngay hoặc xóa toàn bộ dữ liệu đã được lưu tại Vay Có Ngay. Bạn có thể yêu cầu chúng tôi thực hiện các quyền này theo Mục 5. Việc rút lại sự đồng ý không ảnh hưởng đến hoạt động xử lý hợp pháp đã diễn ra trước đó; các thông tin phải lưu giữ theo pháp luật được xử lý theo quy định áp dụng.",
  },
  {
    type: "heading",
    text: "3. Thời hạn ủy quyền xử lý dữ liệu cá nhân",
  },
  {
    type: "paragraph",
    text: "Việc ủy quyền xử lý dữ liệu cá nhân theo Chính sách quyền riêng tư này có hiệu lực kể từ thời điểm bạn xác nhận và chấp nhận chính sách.",
  },
  {
    type: "paragraph",
    text: "Trong thời gian bạn chưa rút lại sự đồng ý hoặc chưa đóng tài khoản, chúng tôi sẽ tiếp tục xử lý dữ liệu cá nhân của bạn trong phạm vi được quy định tại chính sách này.",
  },
  {
    type: "paragraph",
    text: "Khi bạn rút lại sự đồng ý hoặc hoàn tất việc đóng tài khoản (tùy thời điểm nào xảy ra trước), chúng tôi sẽ dừng việc tiếp tục xử lý dữ liệu cá nhân của bạn theo quy định pháp luật hiện hành và chính sách này.",
  },
  {
    type: "paragraph",
    text: "Tuy nhiên, trong các trường hợp sau, chúng tôi có thể tiếp tục lưu trữ dữ liệu theo yêu cầu pháp luật:",
  },
  {
    type: "paragraph",
    text: "Pháp luật yêu cầu phải tiếp tục lưu trữ;",
  },
  {
    type: "paragraph",
    text: "Việc lưu trữ là cần thiết để thực hiện nghĩa vụ pháp lý;",
  },
  {
    type: "paragraph",
    text: "Việc lưu trữ cần thiết để giải quyết tranh chấp hoặc bảo vệ quyền lợi hợp pháp.",
  },
  {
    type: "paragraph",
    text: "Sau khi thời hạn xử lý dữ liệu kết thúc, ngoài các trường hợp nêu trên, chúng tôi sẽ ngừng xử lý dữ liệu cá nhân của bạn và thực hiện các biện pháp hợp lý để xóa hoặc ẩn danh hóa dữ liệu.",
  },
  {
    type: "heading",
    text: "4. Cách chúng tôi lưu trữ và bảo vệ dữ liệu cá nhân",
  },
  {
    type: "paragraph",
    text: "Nhằm đảm bảo an toàn dữ liệu cá nhân của bạn, chúng tôi tuân thủ Luật Bảo vệ dữ liệu cá nhân của Việt Nam (Luật số 10/2023) và Luật An ninh mạng năm 2018, đồng thời áp dụng các biện pháp kỹ thuật và quản lý nhiều lớp để bảo vệ dữ liệu.",
  },
  {
    type: "paragraph",
    text: "Các biện pháp bảo vệ bao gồm nhưng không giới hạn:",
  },
  {
    type: "paragraph",
    text: "Theo yêu cầu tại Điều 5 và Điều 6 của Luật Bảo vệ dữ liệu cá nhân, áp dụng công nghệ mã hóa dữ liệu theo tiêu chuẩn ngành nhằm đảm bảo an toàn dữ liệu trong quá trình truyền tải và lưu trữ;",
  },
  {
    type: "paragraph",
    text: "Theo Điều 26 Luật An ninh mạng, lưu trữ dữ liệu cá nhân trên hệ thống máy chủ an toàn đáp ứng yêu cầu pháp luật Việt Nam, đồng thời thường xuyên thực hiện kiểm tra bảo mật và đánh giá rủi ro;",
  },
  {
    type: "paragraph",
    text: "Kiểm soát nghiêm ngặt quyền truy cập dữ liệu, chỉ cho phép nhân sự được ủy quyền và có trách nhiệm công việc phù hợp truy cập dữ liệu; nhân viên liên quan phải ký cam kết bảo mật theo Điều 11 của Luật Bảo vệ dữ liệu cá nhân;",
  },
  {
    type: "paragraph",
    text: "Xây dựng hệ thống quản lý an toàn thông tin hoàn chỉnh và thường xuyên tổ chức đào tạo nhận thức bảo vệ dữ liệu cho nhân viên;",
  },
  {
    type: "paragraph",
    text: "Áp dụng nhiều biện pháp bảo vệ an ninh như tường lửa, hệ thống chống virus, hệ thống phát hiện xâm nhập nhằm ngăn chặn truy cập trái phép, rò rỉ hoặc thay đổi dữ liệu, phù hợp với Điều 29 Luật An ninh mạng;",
  },
  {
    type: "paragraph",
    text: "Xây dựng quy trình ứng phó sự cố an toàn dữ liệu. Trong trường hợp xảy ra sự cố như rò rỉ, mất mát hoặc thay đổi dữ liệu, chúng tôi sẽ kịp thời kích hoạt cơ chế xử lý khẩn cấp và thông báo cho người dùng cũng như cơ quan có thẩm quyền theo quy định pháp luật.",
  },
  {
    type: "paragraph",
    text: "Chúng tôi cam kết không ngừng hoàn thiện hệ thống bảo vệ dữ liệu cá nhân, nâng cao năng lực bảo mật và đảm bảo quyền lợi hợp pháp của bạn.",
  },
  {
    type: "heading",
    text: "5. Các quyền của bạn",
  },
  {
    type: "paragraph",
    text: "Theo Luật Bảo vệ dữ liệu cá nhân của Việt Nam (PDP Law) và các quy định pháp luật liên quan, với tư cách là chủ thể dữ liệu cá nhân, bạn có các quyền sau đây:",
  },
  {
    type: "heading",
    text: "5.1 Quyền truy cập dữ liệu",
  },
  {
    type: "paragraph",
    text: "Bạn có quyền yêu cầu chúng tôi cung cấp thông tin về dữ liệu cá nhân của bạn mà chúng tôi đang lưu giữ, bao gồm nhưng không giới hạn:",
  },
  {
    type: "paragraph",
    text: "Loại dữ liệu cá nhân được thu thập;",
  },
  {
    type: "paragraph",
    text: "Nguồn dữ liệu;",
  },
  {
    type: "paragraph",
    text: "Mục đích xử lý;",
  },
  {
    type: "paragraph",
    text: "Phương thức xử lý;",
  },
  {
    type: "paragraph",
    text: "Thời gian lưu trữ;",
  },
  {
    type: "paragraph",
    text: "Bạn có quyền tìm hiểu cách chúng tôi thu thập, sử dụng, lưu trữ và bảo vệ dữ liệu cá nhân của bạn, đồng thời có thể yêu cầu cung cấp bản sao dữ liệu cá nhân.",
  },
  {
    type: "paragraph",
    text: "Chúng tôi sẽ xử lý yêu cầu của bạn trong thời gian hợp lý và phản hồi kết quả kịp thời.",
  },
  {
    type: "heading",
    text: "5.2 Quyền chỉnh sửa dữ liệu",
  },
  {
    type: "paragraph",
    text: "Nếu bạn phát hiện dữ liệu cá nhân mà chúng tôi đang lưu giữ có sai sót, không đầy đủ hoặc đã thay đổi, bạn có quyền yêu cầu chúng tôi chỉnh sửa hoặc bổ sung thông tin tương ứng.",
  },
  {
    type: "paragraph",
    text: "Sau khi nhận được yêu cầu, chúng tôi sẽ tiến hành xác minh và hoàn tất việc xử lý trong thời gian hợp lý nhằm đảm bảo dữ liệu cá nhân của bạn luôn chính xác và đầy đủ.",
  },
  {
    type: "heading",
    text: "5.3 Quyền xóa dữ liệu",
  },
  {
    type: "paragraph",
    text: "Trong phạm vi pháp luật cho phép, bạn có quyền yêu cầu chúng tôi xóa dữ liệu cá nhân của mình.",
  },
  {
    type: "paragraph",
    text: "Ví dụ:",
  },
  {
    type: "paragraph",
    text: "Dữ liệu không còn cần thiết cho mục đích thu thập hoặc xử lý ban đầu;",
  },
  {
    type: "paragraph",
    text: "Việc xử lý dữ liệu cá nhân của bạn không tuân thủ quy định pháp luật.",
  },
  {
    type: "paragraph",
    text: "Sau khi nhận được yêu cầu xóa dữ liệu, chúng tôi sẽ tiến hành đánh giá theo quy định và thực hiện việc xóa hoặc ẩn danh hóa dữ liệu khi phù hợp.",
  },
  {
    type: "paragraph",
    text: "Tuy nhiên, trong trường hợp pháp luật yêu cầu tiếp tục lưu trữ dữ liệu, chúng tôi sẽ thực hiện theo các quy định hiện hành.",
  },
  {
    type: "heading",
    text: "5.4 Quyền hạn chế xử lý dữ liệu",
  },
  {
    type: "paragraph",
    text: "Trong một số trường hợp nhất định, bạn có quyền yêu cầu chúng tôi hạn chế việc xử lý dữ liệu cá nhân của bạn.",
  },
  {
    type: "paragraph",
    text: "Ví dụ:",
  },
  {
    type: "paragraph",
    text: "Bạn có nghi ngờ hoặc không đồng ý về tính chính xác của dữ liệu cá nhân;",
  },
  {
    type: "paragraph",
    text: "Bạn phản đối hoạt động xử lý dữ liệu và yêu cầu xác minh thêm.",
  },
  {
    type: "paragraph",
    text: "Chúng tôi sẽ xem xét yêu cầu của bạn trong thời gian hợp lý và áp dụng các biện pháp hạn chế xử lý phù hợp nhằm bảo vệ quyền lợi của bạn.",
  },
  {
    type: "heading",
    text: "5.5 Quyền chuyển dữ liệu",
  },
  {
    type: "paragraph",
    text: "Bạn có quyền yêu cầu chúng tôi cung cấp bản sao dữ liệu cá nhân của bạn dưới định dạng có cấu trúc, thông dụng và có thể đọc được bằng máy, nhằm tạo điều kiện để bạn chuyển dữ liệu sang nhà cung cấp dịch vụ khác.",
  },
  {
    type: "paragraph",
    text: "Chúng tôi sẽ hỗ trợ bạn trong phạm vi hợp lý để đảm bảo việc tiếp nhận và chuyển giao dữ liệu cá nhân được thực hiện thuận tiện và an toàn.",
  },
  {
    type: "heading",
    text: "5.6 Quyền rút lại sự đồng ý",
  },
  {
    type: "paragraph",
    text: "Nếu trước đây bạn đã đồng ý cung cấp dữ liệu cá nhân cho chúng tôi, bạn có quyền rút lại sự đồng ý đó bất kỳ lúc nào.",
  },
  {
    type: "paragraph",
    text: "Sau khi rút lại sự đồng ý:",
  },
  {
    type: "paragraph",
    text: "Chúng tôi sẽ dừng các hoạt động xử lý dữ liệu dựa trên sự đồng ý đó;",
  },
  {
    type: "paragraph",
    text: "Việc rút lại sự đồng ý không ảnh hưởng đến tính hợp pháp của các hoạt động xử lý dữ liệu đã được thực hiện trước thời điểm rút lại.",
  },
  {
    type: "paragraph",
    text: "Xin lưu ý rằng việc rút lại sự đồng ý có thể khiến một số chức năng dịch vụ không thể tiếp tục sử dụng. Trong trường hợp cần thiết, chúng tôi sẽ thông báo cho bạn về những ảnh hưởng liên quan.",
  },
  {
    type: "heading",
    text: "5.7 Quyền khiếu nại",
  },
  {
    type: "paragraph",
    text: "Nếu bạn cho rằng chúng tôi đã xâm phạm quyền và lợi ích hợp pháp của bạn trong quá trình xử lý dữ liệu cá nhân, bạn có quyền gửi khiếu nại đến chúng tôi.",
  },
  {
    type: "paragraph",
    text: "Chúng tôi cam kết tiếp nhận, kiểm tra và xử lý các phản ánh của bạn trong thời gian phù hợp.",
  },
  {
    type: "paragraph",
    text: "Ngoài ra, bạn có quyền gửi khiếu nại hoặc báo cáo đến Cục An toàn thông tin Việt Nam (NCSC) hoặc các cơ quan quản lý có thẩm quyền khác để được bảo vệ quyền lợi theo pháp luật.",
  },
  {
    type: "paragraph",
    text: "Chúng tôi sẽ phối hợp với các cơ quan liên quan trong quá trình xử lý theo quy định.",
  },
  {
    type: "heading",
    text: "5.8 Quyền đóng tài khoản",
  },
  {
    type: "paragraph",
    text: "Bạn có quyền yêu cầu đóng tài khoản của mình bất cứ lúc nào.",
  },
  {
    type: "paragraph",
    text: "Sau khi tài khoản được đóng, chúng tôi sẽ xóa hoặc ẩn danh hóa dữ liệu cá nhân của bạn trong phạm vi pháp luật cho phép.",
  },
  {
    type: "paragraph",
    text: "Nếu pháp luật yêu cầu tiếp tục lưu trữ một số dữ liệu nhất định, chúng tôi sẽ thực hiện theo quy định hiện hành.",
  },
  {
    type: "paragraph",
    text: "Bạn có thể gửi yêu cầu đóng tài khoản thông qua thông tin liên hệ được cung cấp ở cuối Chính sách quyền riêng tư này.",
  },
  {
    type: "paragraph",
    text: "Chúng tôi sẽ xử lý yêu cầu trong thời gian hợp lý và thông báo kết quả cho bạn.",
  },
  {
    type: "paragraph",
    text: "Xin lưu ý rằng việc đóng tài khoản có thể khiến bạn không thể tiếp tục sử dụng một phần hoặc toàn bộ dịch vụ.",
  },
  {
    type: "paragraph",
    text: "Chúng tôi sẽ nỗ lực tối đa để hỗ trợ bạn thực hiện các quyền liên quan đến dữ liệu cá nhân.",
  },
  {
    type: "paragraph",
    text: "Nếu bạn muốn thực hiện bất kỳ quyền nào nêu trên, vui lòng liên hệ với chúng tôi thông qua thông tin liên hệ cuối chính sách.",
  },
  {
    type: "heading",
    text: "6. Cách chúng tôi bảo vệ dữ liệu cá nhân của trẻ vị thành niên",
  },
  {
    type: "paragraph",
    text: "Theo Luật Bảo vệ dữ liệu cá nhân của Việt Nam (Luật số 10/2023) và các quy định pháp luật liên quan, việc bảo vệ dữ liệu cá nhân của trẻ vị thành niên (người dưới 18 tuổi) được đặc biệt quan tâm.",
  },
  {
    type: "paragraph",
    text: "Nhằm bảo vệ quyền và lợi ích hợp pháp của trẻ vị thành niên, khi xử lý dữ liệu cá nhân của nhóm đối tượng này, chúng tôi áp dụng các biện pháp sau:",
  },
  {
    type: "paragraph",
    text: "Trước khi thu thập và sử dụng dữ liệu cá nhân của trẻ vị thành niên, chúng tôi sẽ có được sự đồng ý rõ ràng của người đại diện hợp pháp (như cha mẹ hoặc người giám hộ) theo quy định pháp luật;",
  },
  {
    type: "paragraph",
    text: "Giới hạn nghiêm ngặt phạm vi thu thập dữ liệu cá nhân của trẻ vị thành niên, chỉ thu thập những dữ liệu cần thiết để cung cấp dịch vụ;",
  },
  {
    type: "paragraph",
    text: "Áp dụng các biện pháp bảo mật nghiêm ngặt hơn nhằm ngăn chặn việc rò rỉ, lạm dụng hoặc truy cập trái phép dữ liệu;",
  },
  {
    type: "paragraph",
    text: "Không sử dụng dữ liệu cá nhân của trẻ vị thành niên cho mục đích quảng cáo hoặc các mục đích không cần thiết nếu chưa có sự đồng ý của người giám hộ;",
  },
  {
    type: "paragraph",
    text: "Khi phát hiện dữ liệu cá nhân của trẻ vị thành niên bị thu thập hoặc xử lý trái phép, chúng tôi sẽ kịp thời thực hiện các biện pháp cần thiết để xóa dữ liệu liên quan và thông báo cho người giám hộ.",
  },
  {
    type: "paragraph",
    text: "Chúng tôi cam kết tuân thủ các quy định pháp luật Việt Nam và liên tục bảo vệ an toàn dữ liệu cá nhân của trẻ vị thành niên.",
  },
  {
    type: "heading",
    text: "7. Cập nhật và thông báo về Chính sách quyền riêng tư",
  },
  {
    type: "paragraph",
    text: "Chúng tôi có thể điều chỉnh hoặc cập nhật Chính sách quyền riêng tư này theo sự thay đổi của pháp luật, nhu cầu phát triển kinh doanh hoặc yêu cầu quản lý an toàn thông tin.",
  },
  {
    type: "paragraph",
    text: "Khi chính sách được cập nhật, chúng tôi có thể thông báo cho bạn thông qua các phương thức sau:",
  },
  {
    type: "paragraph",
    text: "Thông báo trong Ứng dụng;",
  },
  {
    type: "paragraph",
    text: "Tin nhắn;",
  },
  {
    type: "paragraph",
    text: "Email;",
  },
  {
    type: "paragraph",
    text: "Các phương thức thông báo hợp lý khác.",
  },
  {
    type: "paragraph",
    text: "Sau khi nhận được thông báo cập nhật, vui lòng đọc kỹ phiên bản mới nhất của Chính sách quyền riêng tư.",
  },
  {
    type: "paragraph",
    text: "Nếu bạn tiếp tục sử dụng sản phẩm hoặc dịch vụ của chúng tôi, điều đó có nghĩa là bạn đã đọc, hiểu và đồng ý với nội dung chính sách được cập nhật.",
  },
  {
    type: "paragraph",
    text: "Nếu bạn không đồng ý với nội dung cập nhật, bạn có quyền ngừng sử dụng dịch vụ liên quan và thực hiện các quyền về dữ liệu cá nhân theo quy định trong chính sách này.",
  },
  {
    type: "paragraph",
    text: "Chúng tôi khuyến nghị bạn thường xuyên kiểm tra Chính sách quyền riêng tư để kịp thời nắm được các biện pháp bảo vệ dữ liệu và quy định dịch vụ mới nhất.",
  },
  {
    type: "heading",
    text: "8. Cách liên hệ với chúng tôi",
  },
  {
    type: "paragraph",
    text: "Nếu bạn có bất kỳ câu hỏi, ý kiến hoặc yêu cầu nào liên quan đến Chính sách quyền riêng tư này hoặc muốn thực hiện các quyền đối với dữ liệu cá nhân của mình, vui lòng liên hệ với chúng tôi thông qua:",
  },
  {
    type: "paragraph",
    text: "Email:\nservice@vaycongay.net",
  },
  {
    type: "paragraph",
    text: "Số điện thoại chăm sóc khách hàng:\n+84-382895190",
  },
  {
    type: "paragraph",
    text: "Địa chỉ văn phòng:\n43 Main Street, Ho Chi Minh City, Ho Chi Minh City 00000, Vietnam",
  },
  {
    type: "paragraph",
    text: "Chúng tôi sẽ phản hồi yêu cầu của bạn trong thời gian sớm nhất và hỗ trợ giải quyết các vấn đề liên quan, nhằm đảm bảo an toàn dữ liệu cá nhân và bảo vệ quyền lợi hợp pháp của bạn.",
  },
];

export default content;
